import Downshift from 'downshift';
import { concat } from 'spark-util/arrays';

const removeItem = (item, array) => array.filter(i => i.value !== item.value);

const isSelected = (selectedItems, item) =>
    selectedItems && selectedItems.some(selected => selected.value === item.value);

const stateReducer = isAsync => (state, changes) => {
    // this prevents the menu from being closed when the user
    // selects an item with a keyboard or mouse
    switch (changes.type) {
        case Downshift.stateChangeTypes.keyDownEnter:
        case Downshift.stateChangeTypes.clickItem:
            const alreadySelected = isSelected(state.selectedItem, changes.selectedItem);
            return {
                ...changes,
                selectedItem: alreadySelected
                    ? removeItem(changes.selectedItem, state.selectedItem)
                    : concat(changes.selectedItem, state.selectedItem),
                inputValue: '',
                isOpen: isAsync ? false : state.isOpen,
                highlightedIndex: isAsync ? null : state.highlightedIndex
            };
        default:
            return changes;
    }
};

export default stateReducer;
